import React, { useRef } from "react";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import "./ErrorModal.scss";
import CustomButton from "../../../../common/CustomButton";

export const ErrorModal = ({ title = "Error", message, onClose }) => {
  const outsideRef = useRef(null);
  useClickOutside(outsideRef, onClose);

  return (
    <div className="error-modal-overlay">
      <div className="error-modal" ref={outsideRef}>
        <div className="error-icon">⚠️</div>
        <div className="error-modal-header">
          <h3>{title}</h3>
        </div>
        <div className="error-modal-body">
          <p>{message}</p>
        </div>
        <div className="error-modal-footer">
          <CustomButton onClick={onClose} fullWidth variant="error">
            OK
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
